<div class="you-chat-log-containter" [ngClass]="{'stickyStyle': fromSticky}">
  <div *ngFor="let timestamp of _timestamps; let last = last;">
    <div class="datetime-seprator" [ngClass]="{'stickyStyle': fromSticky}">{{(timestamp) * 1000 | date:'yyyy-MM-dd HH:mm'}}</div>
    <div class="chat-warning" *ngIf="last">
      <p>注意个人隐私，谨防电信诈骗！</p>
      <p>本站禁止发布：广告，木马链接，非法信息，其它平台联系方式。</p>
      <p>举报核实后，将被封号。</p>
    </div>
    <div class="you-chat-message mb-05" [ngClass]="{'you-chat-message-right': message.type==='SEND', 'more-space': fromSticky && message.notAllowed}"
      *ngFor="let message of _messages[timestamp]; let index=index">
      <div class="you-chat-message__avatar-box">
        <span class="you-chat-message__avatar-frame" [ngClass]="{'stickyStyle': fromSticky}">
          <a *ngIf="message.type==='RECEIVE'" [routerLink]="['/space/', message.uid]" target="_blank" class="avatar-link">
            <img [src]="message.HeadImg" *ngIf="message.type==='RECEIVE'" alt="avatar" class="chat-message__avatar">
          </a>
          <a *ngIf="message.type==='SEND'" [routerLink]="['/space/']" target="_blank" class="avatar-link">
            <img [src]="currentUser?.avatar" *ngIf="message.type==='SEND'" alt="avatar" class="chat-message__avatar">
          </a>
        </span>
        <div *ngIf="message.isOfficalSpeaker" class="you-chat-message__avatar-vip" [ngClass]="{'right': message.type==='SEND', 'stickyStyle': fromSticky}">
          <!-- <img class="vip-icon-path" src="{{'./assets/images/officalSpeaker.png'|absUrl}}"> -->
          <app-membership-icon class="new-icon "
            [membership]="'speaker'"
            [noText]="true" [newIcon]="true">
          </app-membership-icon>
        </div>
        <div *ngIf="message.IsOfficalUP && !message.isOfficalSpeaker" class="you-chat-message__avatar-vip" [ngClass]="{'right': message.type==='SEND', 'stickyStyle': fromSticky}">
          <!-- <img class="vip-icon-path" src="{{'./assets/images/officalUp.png?v=1'|absUrl}}"> -->
          <app-membership-icon class="new-icon"
            [membership]="'bigV'"
            [noText]="true" [newIcon]="true">
          </app-membership-icon>
        </div>
        <div *ngIf="!message.IsOfficalUP && !message.isOfficalSpeaker" class="you-chat-message__avatar-vip" [ngClass]="{'right': message.type==='SEND', 'stickyStyle': fromSticky}">
          <!-- <img class="vip-icon-path" [src]="_resourceService.getBadge(getMembership(message.GID)) |absUrl"> -->
          <app-membership-icon class="new-icon vip"
            [membership]="getMembership(message.GID)"
            [noText]="true" [newIcon]="true">
          </app-membership-icon>
        </div>
      </div>
      <div class="you-chat-message__text" *ngIf="message.messageType==='text'" [innerHTML]="message.context" [ngClass]="{'stickyStyle': fromSticky}"></div>
      <div class="you-chat-message__image" *ngIf="message.messageType==='image'" (click)="showPictureViewer(message)" [ngClass]="{'stickyStyle': fromSticky}">
        <img [src]="message.context + '?w=212'" #msgImg [ngClass]="{'not-loaded': !msgImg.complete}"/>
        <div class="loader-bg">
          <app-loader-spinner></app-loader-spinner>
        </div>
      </div>
      <div class="message-not-allowed" *ngIf="message.notAllowed" [ngClass]="{'stickyStyle': fromSticky}">消息内含有敏感词汇，发送失败。<span class="not-allow-icon">!</span>
      </div>
    </div>
  </div>
  <div *ngIf="isUserBlocked">
    <div class="chat-warning" >该用户已被您拉入黑名单，对方无法发送消息，如需操作，请在关注->黑名单内解除限制</div>
  </div>
  <ng-content></ng-content>
</div>

<app-picture-viewer></app-picture-viewer>
